(() => {
  if (!document.body.classList.contains('gl2-product-style')) return;
  const scope = document.body;
  if (!scope) return;
  const selector = '.product-section flair-badges[layout="products"], .product-recommendations-wrapper flair-badges, .recently-viewed-wrapper flair-badges';
  const watched = new Map();
  let pending = false;
  const palettes = {
    new: ['#f3efe5', '#615841'],
    'special variety': ['#e8eee4', '#3f5745'],
    'out of stock': ['#eeece7', '#5e625e']
  };

  function decorate(host) {
    const root = host.shadowRoot;
    if (!root) return;
    if (!watched.has(host)) {
      const observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      watched.set(host, observer);
    }
    root.querySelectorAll('flair-item').forEach(item => {
      const label = item.shadowRoot?.querySelector('.c')
        || item.querySelector('template')?.content.querySelector('.c');
      const key = label?.textContent.trim().toLowerCase();
      const palette = palettes[key];
      if (!palette) return;
      item.style.setProperty('--flair-background', palette[0]);
      item.style.setProperty('--flair-color', palette[1]);
      if (host.closest('.product-recommendations-wrapper, .recently-viewed-wrapper')) {
        item.style.setProperty('--flair-shape-height', '0px');
        item.style.setProperty('--flair-border-radius', '2px');
        item.style.setProperty('--flair-padding', '3px 9px');
      }
    });
  }

  function refresh() {
    pending = false;
    watched.forEach((observer, host) => {
      if (!host.isConnected) {
        observer.disconnect();
        watched.delete(host);
      }
    });
    scope.querySelectorAll(selector).forEach(decorate);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(refresh);
  }

  Promise.all([
    customElements.whenDefined('flair-badges'),
    customElements.whenDefined('flair-item')
  ]).then(() => {
    refresh();
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (
          node.matches(selector) || node.querySelector(selector)
        )
      ) || Array.from(record.removedNodes).some(node =>
        node.nodeType === 1 && (
          node.matches(selector) || node.querySelector(selector)
        )
      ))) schedule();
    }).observe(scope, { childList: true, subtree: true });
  });
})();

// Keep the vendor's selected panel and accessible tab state in sync after redraws.
(() => {
  if (!document.body.classList.contains('gl2-product-style')) return;
  const config = document.querySelector('script[data-gl2-recommend-summary]');
  if (!config) return;
  let pending = false;
  function refresh() {
    pending = false;
    const widget = document.getElementById('stamped-main-widget');
    if (!widget) return;
    widget.querySelectorAll('.stamped-tabs [role="tab"]').forEach(tab => {
      const selected = String(tab.classList.contains('active'));
      if (tab.getAttribute('aria-selected') !== selected) tab.setAttribute('aria-selected', selected);
      const name = tab.textContent.trim();
      if (name && tab.getAttribute('aria-label') !== name) tab.setAttribute('aria-label', name);
    });
    const labels = [
      ['.stamped-summary-recommend-label', config.dataset.gl2RecommendSummary],
      ['.stamped-review-recommend[data-is-recommend="true"]', config.dataset.gl2RecommendYes],
      ['.stamped-form-review-recommend-label', config.dataset.gl2RecommendQuestion]
    ];
    labels.forEach(([selector, text]) => widget.querySelectorAll(selector).forEach(element => {
      if (text && element.textContent !== text) element.textContent = text;
    }));
    widget.querySelectorAll('option[value="featured"]').forEach(option => {
      if (option.textContent.trim() === 'Sort') option.textContent = config.dataset.gl2Sort;
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(refresh);
  }
  document.addEventListener('click', event => {
    if (event.target.closest?.('#stamped-main-widget .stamped-tabs')) schedule();
  }, true);
  document.addEventListener('keyup', event => {
    if (event.target.closest?.('#stamped-main-widget .stamped-tabs')) schedule();
  }, true);
  refresh();
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeType === 1
      ? record.target.closest('#stamped-main-widget') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'stamped-main-widget' || node.querySelector('#stamped-main-widget')))
      : record.target.parentElement?.closest('#stamped-main-widget'))) schedule();
  }).observe(document.body, {childList: true, subtree: true, characterData: true});
})();

